// extracted by mini-css-extract-plugin
module.exports = {"render":"Render_render__1yqv6"};